import SharedSelectInput from '../shared/SelectInput';

import {
  addMissingMandatoryField,
  removeMissingMandatoryField,
} from 'reducers/commercialFormReducer';

import type { MessageProps } from '../shared/Message/Message.types';

interface CommercialSelectInputProps {
  section: number;
  label: string;
  options: { value: string; label: string }[];
  value: string;
  message?: Omit<MessageProps, 'section'> & { section?: number };
  onChange?: (event: any) => void;
  required?: boolean;
  disabled?: boolean;
  [x: string]: any;
}

const noop = () => ({ type: 'commercialForm/noop' });

const CommercialSelectInput = (props: CommercialSelectInputProps) => {
  const formActions = {
    addMissingMandatoryField,
    removeMissingMandatoryField,
    addRemark: noop,
    removeRemark: noop,
    updateRemark: noop,
    addFile: noop,
    removeFile: noop,
  };

  return (
    <SharedSelectInput
      {...props}
      formStateKey="commercialForm"
      formActions={formActions}
    />
  );
};

export default CommercialSelectInput;
